import React, { useState } from "react";
import { Navbar, Nav, Container, NavDropdown, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useUserAuth } from "../Context/UserAuthContext";
import logo from "../images/lawbot.jpg";

export default function NavigationBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logOut } = useUserAuth();
  const [expanded, setExpanded] = useState(false);

  const handleLogOut = async () => {
    try {
   await logOut();
   navigate("/");
    } catch (err) {
      console.log(err.message);
  }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={setExpanded}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.7)',
        padding: '0.4rem 0'
      }}
    >
      <Container fluid className="px-4">
        {/* Logo */}
        <Navbar.Brand
          as={Link}
          to="/home"
          className="d-flex align-items-center"
          onClick={() => setExpanded(false)}
          style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: '1.35rem',
          fontWeight: '600',
          color: '#c9a961',
          letterSpacing: '0.5px'
          }}
        >
          <img
            src={logo}
            alt="LawBot"
            style={{
              width: '50px',
              height: '50px',
              marginRight: '12px',
              borderRadius: '8px'
            }}
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-nav"
          style={{
            borderColor: 'rgba(201, 169, 97, 0.5)',
            color: '#c9a961'
          }}
        />

        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto" style={{ gap: '0.5rem' }}>
            <Nav.Link
              as={Link}
              to="/home"
              onClick={() => setExpanded(false)}
              className={isActive('/home') ? 'active' : ''}
              style={{
                fontFamily: "'Roboto', sans-serif",
                color: isActive('/home') ? '#c9a961' : '#d4d4d4',
                fontWeight: isActive('/home') ? '500' : '400',
                padding: '0.5rem 1rem',
                borderBottom: isActive('/home') ? '2px solid #c9a961' : '2px solid transparent',
                transition: 'all 0.3s ease',
                fontSize: '0.95rem'
              }}
            >
              Home
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/ask-lawyer"
              onClick={() => setExpanded(false)}
              className={isActive('/ask-lawyer') ? 'active' : ''}
              style={{
                fontFamily: "'Roboto', sans-serif",
                color: isActive('/ask-lawyer') ? '#c9a961' : '#d4d4d4',
                fontWeight: isActive('/ask-lawyer') ? '500' : '400',
                padding: '0.5rem 1rem',
                borderBottom: isActive('/ask-lawyer') ? '2px solid #c9a961' : '2px solid transparent',
                transition: 'all 0.3s ease',
                fontSize: '0.95rem'
              }}
            >
              Ask Lawyer
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/my-queries"
              onClick={() => setExpanded(false)}
              className={isActive('/my-queries') ? 'active' : ''}
              style={{
                fontFamily: "'Roboto', sans-serif",
                color: isActive('/my-queries') ? '#c9a961' : '#d4d4d4',
                fontWeight: isActive('/my-queries') ? '500' : '400',
                padding: '0.5rem 1rem',
                borderBottom: isActive('/my-queries') ? '2px solid #c9a961' : '2px solid transparent',
                transition: 'all 0.3s ease',
                fontSize: '0.95rem'
              }}
            >
              My Queries
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/requirements"
              onClick={() => setExpanded(false)}
              className={isActive('/requirements') ? 'active' : ''}
              style={{
                fontFamily: "'Roboto', sans-serif",
                color: isActive('/requirements') ? '#c9a961' : '#d4d4d4',
                fontWeight: isActive('/requirements') ? '500' : '400',
                padding: '0.5rem 1rem',
                borderBottom: isActive('/requirements') ? '2px solid #c9a961' : '2px solid transparent',
                transition: 'all 0.3s ease',
                fontSize: '0.95rem'
              }}
            >
              Requirements
            </Nav.Link>

            <NavDropdown
              title={<span style={{ color: '#d4d4d4' }}>Posts</span>}
              id="posts-dropdown"
              style={{
                fontFamily: "'Roboto', sans-serif",
                fontSize: '0.95rem'
              }}
            >
              <NavDropdown.Item
                as={Link}
                to="/my-posts"
                onClick={() => setExpanded(false)}
                style={{
                  fontFamily: "'Roboto', sans-serif",
                  color: '#d4d4d4',
                  backgroundColor: 'rgba(20, 20, 20, 0.95)',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
                  fontSize: '0.95rem'
                }}
              >
                My Posts
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/all-posts"
                onClick={() => setExpanded(false)}
                style={{
                  fontFamily: "'Roboto', sans-serif",
                  color: '#d4d4d4',
                  backgroundColor: 'rgba(20, 20, 20, 0.95)',
                  fontSize: '0.95rem'
                }}
              >
                All Posts
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>

          {user && (
            <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
              <span
                style={{
                  color: '#c9a961',
                  fontFamily: "'Roboto', sans-serif",
                  fontWeight: '500',
                  fontSize: '0.9rem'
                }}
              >
                {user.displayName || user.email}
              </span>
              <Button
                variant="outline-warning"
                size="sm"
                onClick={handleLogOut}
                style={{
                  borderColor: '#c9a961',
                  color: '#c9a961',
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: '500',
                  padding: '0.4rem 1rem',
                  transition: 'all 0.3s ease',
                  fontSize: '0.9rem'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#c9a961';
                  e.target.style.color = '#1a1a1a';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#c9a961';
                }}
              >
                Logout
              </Button>
        </div>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
